import * as React from 'react'
import { StyledGrid } from '$views/components/Grid/Grid.style'
import { SizeName } from '$utils/theme/size'

interface Props {
  columns: number
  rows: number
  columnGap?: SizeName
  rowGap?: SizeName
  alignItemsCentered?: boolean
  justifyContentCentered?: boolean
  columnFitContent?: boolean
}

export const Grid: React.SFC<Props> = props => {
  return <StyledGrid {...props}>{props.children}</StyledGrid>
}



// WEBPACK FOOTER //
// ./src/views/components/Grid/Grid.tsx